import { TacticalPlanApi } from './TacticalPlanApi';
import { Api } from '@automapa/svelte-automapa-template';
import { WeekSchedule } from '../../utilities/WeekSchedule';
import { _ } from 'svelte-i18n';
import { get } from 'svelte/store';
import { TacticalPlanRuleApi } from './TacticalPlanRuleApi';
import { getEmptyDefaultRule } from './TacticalPlanRule';
import { week } from '../../utilities/mockWeekSchedule';
import { TacticalPlan } from './TacticalPlan';
import { Navigation } from '../../utilities/Navigation';
import { Umami } from '../../utilities/Umami';

function getFirstNotSetWeekDay(week, bitSum: number): number {
    for (let day of week) {
        if (!WeekSchedule.isChecked(day.id, bitSum)) {
            return day.id;
        }
    }
    return 0;
}

export function createTacticalPlan(api: Api, tacticalPlans: TacticalPlan[]) {
    TacticalPlanApi.createOne(api, {
        name: get(_)('New tactical plan'),
        week_schedule: getFirstNotSetWeekDay(
            week,
            WeekSchedule.getSum(tacticalPlans.map(tp => tp.getWeekSchedule()))
        ),
    })
        .then(response => {
            let newTP = response;
            let firstRule = getEmptyDefaultRule(newTP.id);
            firstRule.setAlwaysLast();
            firstRule.selectActionType('unset');
            TacticalPlanRuleApi.createOne(api, firstRule.getRuleReadyToRequest())
                .then(response => {
                    // tacticalPlans = [...tacticalPlans, newTP];
                    // tacticalPlans = [...tacticalPlans, new TacticalPlan(newTP)];
                    Umami.event('tactical_plan_add', { id: newTP.id });
                    Navigation.navigate(`/tactical-plan/${newTP.id}`);
                })
                .catch(error => {
                    Umami.error('tactical_plan_add', error);
                    console.log(error);
                });
        })
        .catch(error => {
            Umami.error('tactical_plan_add', error);
            console.log(error);
        });
}
